<template lang="html">
  <div class="select">
    <select
      class="custom-select"
      v-model="newValue">
      <option disabled value="">Please select one</option>
      <option
        v-for="(item, key) in items"
        :key="key"
        :value="item">{{ item[itemKeys.display]}}</option>
    </select>
    <div v-if="errorMessage" class="invalid-feedback">{{ errorMessage[0] }}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      newValue: null
    }
  },
  props: {
    value: {},
    items: {},
    fullItem: false,
    errorMessage: {},
    itemKeys: {
      default () {
        return { display: 'name' }
      }
    }
  },
  mounted () {
    this.newValue = this.value
    if (!this.value) {
      this.newValue = ''
    }
  },
  watch: {
    newValue (value) {
      this.$emit('input', value)
      this.$emit('select', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.small-margin {
  margin: 5px;
}
</style>
